import { toGlobalId } from 'src/helpers/getIntegerId';

export const getOrganizationLinkId = (pathname: string): string | null => {
    const segments = pathname.split('/');
    const isVendor = segments[1] === 'vmc';
    const code = segments[isVendor ? 2 : 1];
    if (!code || !/^[a-z0-9]+$/i.test(code)) {
        return null;
    }

    const trackingId = Number.parseInt(code, 36);
    if (
        !Number.isSafeInteger(trackingId) ||
        trackingId <= 0 ||
        trackingId > 2_147_483_647 ||
        trackingId.toString(36) !== code.toLowerCase()
    ) {
        return null;
    }

    return toGlobalId(isVendor ? 'VendorOrganizationNode' : 'ClientOrganizationNode', trackingId);
};
